import type { ReactNode } from "react"
import Popover from "@/v2-ui/popover"
import { useSelectorContext } from "./selector.context"
import SelectorCommand from "./SelectorCommand"

export type SelectorContentProps = {
  children: ReactNode
}

function SelectorContent(props: SelectorContentProps) {
  const { children } = props
  const { shouldFilter, portal } = useSelectorContext()

  return (
    <Popover.Content
      align="start"
      className="selector-content p-0"
      skipPortal={!portal}
    >
      <SelectorCommand shouldFilter={shouldFilter}>{children}</SelectorCommand>
    </Popover.Content>
  )
}

export default SelectorContent
